import { Button } from 'antd'
import React from 'react'
import { useLingui } from '@lingui/react/macro'

import type { ButtonProps } from 'antd'

import { CssIcon } from '@/components/CssIcon'

export interface CreateButtonProps
  extends Pick<ButtonProps, 'onClick' | 'loading' | 'disabled'> {
  text?: string
  className?: string
}

const CreateButton: React.FC<CreateButtonProps> = (props) => {
  const { t } = useLingui()
  const { loading, disabled, text = t`Create`, className, ...rest } = props
  return (
    <Button
      {...rest}
      htmlType='submit'
      block
      type='primary'
      className={cls`${className} flex items-center text-lg font-semibold`}
      size='large'
      disabled={disabled}
    >
      <CssIcon
        className={`${loading ? 'i-cus--tad-loading animate-spin' : 'i-cus--tad-create'} size-6`}
      />
      <span>{text}</span>
    </Button>
  )
}

export default CreateButton
